module.exports = __webpack_public_path__ + "img/license.c0e95cf1.png";